import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";

//ANT DESIGN IMPORTS
import { Typography, Card, Spin, Form } from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import appStatic from "../../../config/appStatic";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import styles from "../../../assets/styles/styles";
import { rightAction } from "../../../redux/actions";

import SMS from "./tab/SMS";
import Email from "./tab/Email";
import Token from "./tab/Token";
const { Text, Title } = Typography;

const DetailTwoFA = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const [useForm] = Form.useForm();

  const [smsList, setSmsList] = useState([]);
  const [emailList, setEmailList] = useState([]);
  const [tokenList, setTokenList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const [activeTabKey, setActiveTabKey] = useState("sms");
  const childref = useRef();
  const tabList = [
    {
      label: "SMS",
      key: "sms",
      disabled: !BOM.HasPermission("READ_TWOFACTOR_CONFIG"),
    },
    {
      label: "Email",
      key: "email",
      disabled: !BOM.HasPermission("READ_TWOFACTOR_CONFIG"),
    },
    {
      label: "Token",
      key: "token",
      disabled: !BOM.HasPermission("READ_TWOFACTOR_CONFIG"),
    },
  ];

  useEffect(() => {
    getCongfigList();
  }, []);

  const getCongfigList = () => {
    const url = `${apiConfig.TwoFactor}/configure`;

    let body = {
      session,
    };

    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;

        let tempSMSArray = [
          {
            key: "1",
            name: labelConfig.otpDeliverySmsEnable,
            value: objList[labelConfig.otpDeliverySmsEnable] ? "true" : "false", //convert to string
          },
          {
            key: "2",
            name: labelConfig.otpDeliverySmsProvider,
            value: objList[labelConfig.otpDeliverySmsProvider],
          },

          {
            key: "3",
            name: labelConfig.otpDeliverySmsText,
            value: objList[labelConfig.otpDeliverySmsText],
          },
        ];

        let tempEmailArray = [
          {
            key: "1",
            name: labelConfig.otpDeliveryEmailEnable,
            value: objList[labelConfig.otpDeliveryEmailEnable]
              ? "true"
              : "false", //convert to string
          },
          {
            key: "2",
            name: labelConfig.otpDeliveryEmailSubject,
            value: objList[labelConfig.otpDeliveryEmailSubject],
          },

          {
            key: "3",
            name: labelConfig.otpDeliveryEmailBody,
            value: objList[labelConfig.otpDeliveryEmailBody],
          },
        ];

        let tempTokenArray = [
          {
            key: "1",
            name: labelConfig.otpTokenLength,
            value: objList[labelConfig.otpTokenLength],
          },
          {
            key: "2",
            name: labelConfig.accessTokenLiveTimeExtended,
            value: objList[labelConfig.accessTokenLiveTimeExtended],
          },

          {
            key: "3",
            name: labelConfig.otpTokenLiveTime,
            value: objList[labelConfig.otpTokenLiveTime],
          },
          {
            key: "4",
            name: labelConfig.accessTokenLiveTime,
            value: objList[labelConfig.accessTokenLiveTime],
          },
        ];

        setSmsList(tempSMSArray);
        setEmailList(tempEmailArray);
        setTokenList(tempTokenArray);

        useForm.setFieldsValue({
          [labelConfig.otpDeliverySmsEnable]:
            objList[labelConfig.otpDeliverySmsEnable],
          [labelConfig.otpDeliverySmsProvider]:
            objList[labelConfig.otpDeliverySmsProvider],
          [labelConfig.otpDeliverySmsText]:
            objList[labelConfig.otpDeliverySmsText],
          [labelConfig.otpDeliveryEmailEnable]:
            objList[labelConfig.otpDeliveryEmailEnable],
          [labelConfig.otpDeliveryEmailSubject]:
            objList[labelConfig.otpDeliveryEmailSubject],
          [labelConfig.otpDeliveryEmailBody]:
            objList[labelConfig.otpDeliveryEmailBody],
          [labelConfig.otpTokenLength]: objList[labelConfig.otpTokenLength],
          [labelConfig.accessTokenLiveTimeExtended]:
            objList[labelConfig.accessTokenLiveTimeExtended],
          [labelConfig.otpTokenLiveTime]: objList[labelConfig.otpTokenLiveTime],
          [labelConfig.accessTokenLiveTime]:
            objList[labelConfig.accessTokenLiveTime],
        });

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const onTabChange = (key) => {
    // console.log(key);
    setActiveTabKey(key);
  };

  const contentListNoTitle = {
    sms: (
      <SMS
        configList={smsList}
        refreshList={getCongfigList}
        userData={userData}
        useForm={useForm}
      />
    ),
    email: (
      <Email
        configList={emailList}
        refreshList={getCongfigList}
        userData={userData}
        useForm={useForm}
      />
    ),
    token: (
      <Token
        configList={tokenList}
        refreshList={getCongfigList}
        userData={userData}
        useForm={useForm}
      />
    ),
  };

  function handleOnActivateClose() {
    console.log();
    childref?.current?.showModal();
  }

  const steps = ["sms", "email", "token"];

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onApprove={() => handleOnActivateClose()}
      onReject={() => handleOnActivateClose()}
      currentStep={steps[tabList.findIndex((tab) => tab.key === activeTabKey)]}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailTwoFactorConfig}
        pageItems={staticConfig.detailTwoFactorConfigBreadrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {BOM.HasPermission("READ_TWOFACTOR_CONFIG") &&
            contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailTwoFA);
